import React from 'react';
import { connect } from 'react-redux';
import Slideshow from './../../Slideshow.jsx';
import SocialButtons from './../../SocialButtons.jsx';
import SmallInlineVideoCard from './SmallInlineVideoCard.jsx';


class SmallTitleCard extends React.Component {
  constructor(props) {
    super(props);


    // used by React as the component name
    this.displayName = 'SmallTitleCard';

    // bind functions to component
    this.renderTopElement = this.renderTopElement.bind(this);
    this.renderSubTitle = this.renderSubTitle.bind(this);
  }


  /**
   * Renders top element
   * @returns {ReactElement} ReactElement
   */
  renderTopElement() {
    const state = this.props.smallCardFrameworkState;
    const data = this.props.data;
    const active = (state.currentCardIteration + 1 === data.order);
    let element;

    if (data.images) {
      element = (
        <Slideshow
          active={active}
          data={data.images}
          id={data.order}
          largeBreakpoint={this.props.largeBreakpoint}
        />
      );
    } else if (data.video.small) {
      const style = {
        height: window.innerHeight,
      };

      element = (
        <SmallInlineVideoCard
          autoplay
          data={data.video.small}
          iteration={0}
          key={'title-card-video-' + data.order}
          style={style}
          showImageForUnsupportedAutoplay
        />
      );
    }

    return element;
  }


  /**
   * Renders subtitle
   * @returns {ReactElement} ReactElement
   */
  renderSubTitle() {
    const data = this.props.data;
    let element;

    if (data.subtitle) {
      element = (
        <div
          className='subtitle'
          dangerouslySetInnerHTML={{ __html: data.subtitle }}
        />
      );
    }

    return element;
  }


  /**
   * Renders component
   * @returns {ReactElement} ReactElement
   */
  render() {
    const topElement = this.renderTopElement();
    const subtitle = this.renderSubTitle();
    const state = this.props.smallCardFrameworkState;
    const data = this.props.data;
    const active = (state.currentCardIteration + 1 === data.order);
    const activeClass = active ? ' active' : '';
    const mediaClass = data.video ? ' video' : ' images';
    const className = 'card component-small-title-card' +
      activeClass +
      mediaClass;

    return (
      <section
        className={className}
        style={this.props.style}
      >
        <div className='content'>
          {topElement}
          <div className='text'>
            <div
              className='title'
              dangerouslySetInnerHTML={{ __html: data.title }}
            />
            {subtitle}
          </div>
        </div>
        <a
          className='logo'
          href='http://bleacherreport.com/br-mag'
        />
        <SocialButtons
          shareText={data.title}
          shareUrl={window.location.href}
        />
      </section>
    );
  }
}


/**
 * Expected propTypes
 * @prop {Object} data - An array of card React components
 * @prop {Number} iteration - The iteration of the component
 * @prop {Number} largeBreakpoint - The screen width at which the large image
 * size should be shown
 * @prop {Object} mediaLabCardFrameworkState - The state of the
 * container component
 * @prop {Object} smallCardFrameworkState - The state of the
 * SmallCardFramework component
 * @prop {Object} style - A style object
 */
SmallTitleCard.propTypes = {
  data: React.PropTypes.object.isRequired,
  iteration: React.PropTypes.number.isRequired,
  largeBreakpoint: React.PropTypes.number.isRequired,
  mediaLabCardFrameworkState: React.PropTypes.object.isRequired,
  smallCardFrameworkState: React.PropTypes.object.isRequired,
  style: React.PropTypes.object,
};


export default connect(({ mediaLabCardFrameworkState, smallCardFrameworkState }) =>
  ({ mediaLabCardFrameworkState, smallCardFrameworkState }))(SmallTitleCard);



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/cards/small/SmallTitleCard.jsx
 **/